import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayLabelFilter'
})
export class ArrayLabelFilterPipe implements PipeTransform {

  transform(items: any[], value: string, field = 'label'): any[] {
    if (!items) {
      return [];
    }

    if (!field || value == null) {
      return items;
    }

    return [...items.filter(item => item[field] ? item[field].toLowerCase().includes(value.trim().toLowerCase()) : true)];
  }

}
